<ng-container *ngIf="reloadRequired | async">
    <div class="alert--refresh"></div>
    <a class="mvd_navbar__link alert--refresh__link" role="button" href="javascript:void(0)" title="A new version of MAX is available.&#10;Click here to reload." (click)="reloadPage()">
        <i class="material-icons">autorenew</i>
    </a>
</ng-container>
